const CALL_OFF_AUTOMATION_MODAL_SUBDOMAINS = ['santa-anita-test', 'caracas-test', 'san-gregorio-test', "san-sebastian-test", 'tcit', 'dev', 'test'];
const INCOMING_DELIVERY_REFERENCE_SUBDOMAINS = [
  'santa-anita-test',
  'caracas-test',
  'tcit',
  'dev',
  'test',
  'san-gregorio-test', "san-sebastian-test"
];

const OPEN_PROCESSES_STATUS_DEFAULT_SUBDOMAINS = ['santa-anita-test', 'caracas-test', 'tcit', 'san-gregorio-test', "san-sebastian-test", 'dev', 'test'];
const AUTOMATION_FOUR_LABEL_COPIES_SUBDOMAINS = ['santa-anita-test', 'caracas-test', 'tcit', 'dev', 'san-gregorio-test', "san-sebastian-test", 'test'];

const isEnabledForSubdomain = (enabledSubdomains = []) => {
  if (typeof window === 'undefined') return false;

  const subdomain = window.location.hostname.split('.')[0];
  return enabledSubdomains.includes(subdomain);
};

export const shouldUseCallOffInAutomationModals = () =>
  isEnabledForSubdomain(CALL_OFF_AUTOMATION_MODAL_SUBDOMAINS);

export const shouldUseCallOffInTraceabilityGraph = () =>
  isEnabledForSubdomain(CALL_OFF_AUTOMATION_MODAL_SUBDOMAINS);

export const shouldShowIncomingDeliveryReference = () =>
  isEnabledForSubdomain(INCOMING_DELIVERY_REFERENCE_SUBDOMAINS);

export const shouldDefaultProcessesStatusToOpen = () =>
  isEnabledForSubdomain(OPEN_PROCESSES_STATUS_DEFAULT_SUBDOMAINS);

export const shouldPrintFourAutomationLabelsPerPak = () =>
  isEnabledForSubdomain(AUTOMATION_FOUR_LABEL_COPIES_SUBDOMAINS);
